module.exports = __webpack_public_path__ + "img/header-weddingRingsRedgold@2x.f8b5538.webp";